import { extendTheme } from '@chakra-ui/react';

const { breakpoints: defaultBreakpoints } = extendTheme();

export default {
  mobile: defaultBreakpoints.md,
};
